<template>
<div class="container">
  <div class="titles">
    <h2 class="text-center text-muted">
      Set your Payments
    </h2>
  </div>

  <b-container class="bv-example-row bv-example-row-flex-cols">
    <b-row align-h="center">
      <b-col sm="12" md="12" lg="8" class="box shadow-sm">
        <NewCalc />
        <div class="payments-select">
          <!-- <label class="mr-md-2">I would like to pay in</label>
      <b-form-select v-model="paymentMethod">
        <option
          v-for="paymentMethod in paymentMethods"
          :key="paymentMethod"
        >
          {{ paymentMethod }}
        </option>
      </b-form-select> -->
          <button class="btn btn-success" @click="next">
            Select
          </button>
        </div>
      </b-col>
    </b-row>

  </b-container>

</div>
</template>

<script>
import NewCalc from '../components/new_calc'

export default {
  name: 'PaymentCustomize',
  components: {
    NewCalc,
  },
  // data() {
  //   return {
  //     paymentMethod: 'Cash',
  //     paymentMethods: ['Cash', 'Debit', 'Credit'],
  //   }
  // },
  mounted() {
    document.querySelector('.navbar').classList.add('darkHeader')
    if (!this.$store.state.userData.carDetails) {
      this.$router.push({
        name: 'Home',
      })
    }
  },
  methods: {
    next() {
      this.$store.state.userData.paymentMethod = this.paymentMethod
      this.$router.push({
        name: 'CreateUser',
      })
    },
  },
}
</script>

<style scoped>
.titles {
  padding-top: 3rem;
}
.container {
  margin-top: 4rem;
  margin-bottom: 6rem;
}

.box {
  /* margin: 0 7rem; */
  padding: 2rem;
  border-top: 3px solid #40c991;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  display: block;
  margin: 3rem auto 0;
}

.payments-select {
  margin-top: 34px;
}

.payments-select select {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/pages/payment_customize.vue